<template>
  <main
    class="app-layout-content"
    :class="{
      padding,
    }"
  >
    <slot />
  </main>
</template>

<script>
export default {
  name: 'AppLayoutContent',

  props: {
    padding: {
      type: Boolean,
      default: false,
    },

    negativeRadiusBottom: {
      type: Boolean,
      default: true,
    },
  },
}
</script>

<style lang="scss" scoped>
@use '@/styles/settings.scss' as *;

.app-layout-content {
  $padding: 28px;
  display: flex;
  flex: 1;
  flex-direction: column;
  width: 100%;
  // min-height: stretch;
  position: relative;
  z-index: 4;

  // & ~ :deep(.app-layout-footer.fixed) {
  //   overflow: auto;
  //   z-index: 6;
  // }

  &.padding {
    padding: $padding;
  }

  :deep(.loading-container) {
    margin-top: 0;
  }

  > :deep(.app-wrapper) > .app-layout,
  > :deep(.app-layout) {
    min-height: 0;
  }

  > :deep(.app-card:only-child) {
    flex: 1;
    display: flex;
    flex-direction: column;

    &.no-padding {
      overflow: hidden;
    }
  }
}
</style>
